/**
 * Upload staged KYC documents one by one. A failed document never loses the
 * saved employee, but it is RETURNED so HR can be told which ones to retry.
 */
export async function uploadKycDocs<T extends { label: string }>(
  docs: T[],
  upload: (doc: T) => Promise<void>,
): Promise<T[]> {
  const failed: T[] = [];
  for (const doc of docs) {
    try {
      await upload(doc);
    } catch {
      failed.push(doc);
    }
  }
  return failed;
}
